var React = require('react');

function Fighter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Light Fighter"),React.createElement("g",{"id":"layer1","key":2},[React.createElement("path",{"id":"path1402","className":"cls-1","d":"M104,51.71l-30,30H54l-30-30","key":0}),React.createElement("path",{"id":"path1404","className":"cls-1","d":"M114,81.71v-30l-10-10H24l-10,10v30","key":1})])]);
}

Fighter.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Fighter;

Fighter.default = Fighter;
